.markdown {
  line-height: 1.5em;

  a:not([data-page-link-breadcrumb]) {
    color: var(--color-primary);
    text-decoration: underline;
  }

  p {
    margin-bottom: 0.5em;
    margin-top: 0.5em;
  }

  table {
    margin-bottom: 1.5rem;
  }

  ol {
    list-style-type: decimal;
    margin-inline-start: 1.5rem;
  }

  ul {
    list-style-type: disc;
    margin-inline-start: 1.5rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1.5em;
    margin-bottom: 0.5em;

    &:first-child {
      margin-top: 0;
    }
  }
}
